/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type {
  DlcMessagedProperty as DlcMessagedPropertyType,
  DlcRawMessagedProperty,
} from '@zcode/state-type'

import { Bizo, autoclass } from '../../shared/bizos/base'

export const DlcMessagedProperty = autoclass<DlcMessagedPropertyType, DlcRawMessagedProperty>(
  'DlcMessagedProperty',
  class DlcMessagedProperty extends Bizo<DlcMessagedPropertyType, DlcRawMessagedProperty> {},
  {
    listingId: 'listing_id',
    buildingId: 'building_id',
  }
)

export const DlcMessagedProperties = {
  fromJS: (messagedPropertyIds: DlcRawMessagedProperty | undefined) => {
    if (messagedPropertyIds?.listing_id || messagedPropertyIds?.building_id) {
      return DlcMessagedProperty.fromJS(messagedPropertyIds)
    }
  },
}
